import { AssignmentTwoTone } from "@mui/icons-material";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  Grid,
  Grow,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from "@mui/material";
import React, {useEffect, useState, useContext} from 'react'
import { PreventiviNewContext } from '../../context'
import {useForm} from "../../hooks"
import { CurrencySimbol } from "../../utilities";
import { v4 as uuidv4 } from "uuid";

const Contrassegno = ({prevMainForm, setPrevMainForm}) => {
    const [contrassegnoChecked, setContrassegnoChecked] = useState(false/*nuovoPreventivoForm.sceltaContrassegno*/);

    const {
        state: { valuteList, tipiIncassi },
        getTipiIncassi,
        getValute,
      } = useContext(PreventiviNewContext);

    const {
        values: contrassegnoForm,
        changeHandler,
        setValues,
      } = useForm(
        {
          TipoIncassoCOD: " ",
          ImportoCOD: "",
          ValutaCOD: "EUR",
          IncassoCodice : "",
          IncassoDescrizione : "",
        },
        []
    );



    useEffect(() => {

      if (prevMainForm?.ImportoCOD !== "" && prevMainForm.ImportoCOD !== undefined) {
        setValues({
          ...contrassegnoForm,
          ValutaCOD : prevMainForm?.ValutaCOD,
          ImportoCOD : prevMainForm?.ImportoCOD,
          TipoIncassoCOD : prevMainForm?.TipoIncassoCOD
        })
        setContrassegnoChecked(true)
      }        
    }, [prevMainForm.ordadr]);

    function getDescrizionePerTipoIncasso(incassoCodice){
      let ret = "";
      tipiIncassi.map((row) =>{
        if(row.codice === incassoCodice){
          ret = row.descrizione;
        };
      });
      return ret;
    }
   
    useEffect(() => {
        getTipiIncassi();
        getValute();
      }, []);

    useEffect(() => {
        if (!contrassegnoChecked) {
            setValues({
                ...contrassegnoForm,
                TipoIncassoCOD: " ",
                ImportoCOD: "",
                ValutaCOD: "EUR",
                IncassoDescrizione : ""
              });
            }
            setValues({ ...contrassegnoForm, sceltaContrassegno: contrassegnoChecked });
        
          }, [contrassegnoChecked]);
      
    useEffect(() => {
        setPrevMainForm({ ...prevMainForm, 
              TipoIncassoCOD: contrassegnoForm.TipoIncassoCOD,
              ImportoCOD: contrassegnoForm.ImportoCOD,
              ValutaCOD: contrassegnoForm.ValutaCOD,
              IncassoDescrizione: getDescrizionePerTipoIncasso(contrassegnoForm.TipoIncassoCOD),
            });
        }, [contrassegnoForm]);

  return (
<   Card
            elevation={0}
            sx={{ background: (theme) => theme.palette.info.main + "20" }}
          >
            <CardHeader
              title={"Contrassegno"}
              subheader={""}
              subheaderTypographyProps={{
                fontWeight: "bold",
              }}
              titleTypographyProps={{
                fontWeight: "bold",
                fontSize: 18,
              }}
              avatar={<AssignmentTwoTone />}
              action={
                <FormControlLabel
                  control={
                    <Switch checked={contrassegnoChecked} onClick={() => setContrassegnoChecked(!contrassegnoChecked)} />
                  }
                  label=""
                />
              }
            />

            {contrassegnoChecked ? (
              <Grow in={contrassegnoChecked} timeout={{ appear: 1000, enter: 1000, exit: 1000 }}>
                <CardContent>
                  <Grid item container spacing={1}>
                    <Grid item xs={12} md={4} lg={4} mt={2}>
                      <FormControl fullWidth>
                        <InputLabel id="select-from-nations">Tipo incasso</InputLabel>
                        <Select
                          fullWidth
                          size="small"
                          labelId="select-from-nations"
                          id="select-from-nations"
                          value={prevMainForm.TipoIncassoCOD || ""}
                          onChange={(e) => {
                            changeHandler("TipoIncassoCOD", e.target.value)

                          }
                          }
                          label="Tipo incasso"
                        >
                          <MenuItem value={" "} key={uuidv4()}>Seleziona tipo incasso</MenuItem>
                          {tipiIncassi?.map((params, key) => (
                            <MenuItem key={key} value={params.codice}>
                              {params.codice} - {params.descrizione}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4} mt={2}>
                      <FormControl fullWidth>
                        <InputLabel id="select-from-nations">Valuta</InputLabel>
                        <Select
                          fullWidth
                          size="small"
                          labelId="select-from-nations"
                          id="select-from-nations"
                          value={prevMainForm.ValutaCOD || ""}
                          onChange={(e) => changeHandler("ValutaCOD", e.target.value)}
                          label="Valuta"
                        >
                          <MenuItem key={uuidv4()} value={" "}>Seleziona valuta</MenuItem>
                          {valuteList?.map((params, key) => (
                            <MenuItem key={key} value={params.codice}>
                              {params.codice} - {params.descrizione}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Importo"
                        autoComplete="off"
                        value={prevMainForm.ImportoCOD || ""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {CurrencySimbol(prevMainForm.ValutaCOD)}
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) => changeHandler("ImportoCOD", e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Grow>
            ) : (
              <></>
            )}
          </Card>  )
}

export default Contrassegno